module.exports = __webpack_public_path__ + "static/media/Brownstones-of-Westland-Bylaws.fe85e65d.pdf";